import React from 'react';
import { StringColumn, CustomColumn } from 'baseui/data-table';

export const COL_NAMES = {
	code: 'code',
	subHeading: 'subHeading',
	description: 'description',
	info: 'info',
	validity: 'validity',
	type: 'type',
	paymentModes: 'paymentModes'
};

export const columnConfigs = [
	StringColumn({
		title: 'Coupon Code',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.code] || ''
	}),
	StringColumn({
		title: 'Sub Heading',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.subHeading] || ''
	}),
	CustomColumn({
		title: 'Description',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.description] || '',
		renderCell: (params: any) => {
			const { value } = params;
			let descriptionCompress = '';
			if (value.length > 30) {
				descriptionCompress = `${value.substr(0, 30)}...`;
			} else {
				descriptionCompress = value;
			}

			return <div title={value}>{descriptionCompress}</div>;
		}
	}),
	CustomColumn({
		title: 'Info',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.info],
		renderCell: (params: any) => {
			const { value } = params;
			let InfoText = '';
			const arr = value.split('</li>');
			for (let i = 0; i < arr.length - 1; i += 1) {
				const InfoStr = arr[i].replace(/<[^>]+>/g, '');
				InfoText = `${InfoText} [${i + 1}] ${InfoStr}.`;
			}
			let InfoCompress = '';
			if (InfoText.length > 30) {
				InfoCompress = `${InfoText.substr(0, 30)}...`;
			} else {
				InfoCompress = InfoText;
			}

			return <div title={InfoText}>{InfoCompress}</div>;
		}
	}),
	StringColumn({
		title: 'Validity',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.validity] || ''
	}),
	StringColumn({
		title: 'Type',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.type] || ''
	}),
	CustomColumn({
		title: 'Payment Modes',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.paymentModes] || '',
		renderCell: (params: any) => {
			const { value } = params;
			const paymentModes = JSON.stringify(value, null, 2);
			let allTypes = '';
			for (let i = 0; i < value.length; i += 1) {
				if (i === value.length - 1) {
					allTypes = `${allTypes}${value[i].type}`;
				} else {
					allTypes = `${allTypes}${value[i].type}, `;
				}
			}

			return <div title={paymentModes}>{allTypes}</div>;
		}
	})
];
